export default "__VITE_ASSET__D0guME7c__"